import { EnvironmentProviders, Provider } from '@angular/core';
import { provideQarepaApiErrors } from '@qarepa/common';
import {
  apiErrorDictionary,
  bypassErrorCodes,
} from '@qaroni-merchant-core/config/api-errors/api-errors';
import { ApiErrorPresenter } from 'libono';

export const provideApiError = (): (Provider | EnvironmentProviders)[] => {
  return provideQarepaApiErrors({
    dictionary: apiErrorDictionary,
    bypassApiErrorCodes: bypassErrorCodes,
    presenter: ApiErrorPresenter,
  });
};
